import { render, staticRenderFns } from "./VesselOwnerHistory.vue?vue&type=template&id=5bf95b86&scoped=true&"
import script from "./VesselOwnerHistory.vue?vue&type=script&lang=js&"
export * from "./VesselOwnerHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf95b86",
  null
  
)

export default component.exports